import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Environment } from './model/environment';

import {AuthService, AutoLogoutService, LoggingService} from '@auth-suite-services/services';
import { mbeConfigService  } from './services/mbe-config.service';
import {StatmentDescriptionCodeService} from './services/statment-description-code.service';
import {BankAccountServiceService} from './services/bank-account-service.service';
import {BfeeDetailService} from './services/bfee-detail.service';
import {BfeeGroupService} from './services/bfee-group.service';
import {BfeeSourceService} from './services/bfee-source.service';
import {ChartOfAccountService} from './services/chart-of-account.service';
import {FeeSourceService} from './services/fee-source.service';
import {FinancialService} from './services/financial.service';
import {NotificationService} from './services/notification.service';
import {RiskClassService} from './services/risk-class.service';
import {SourceService} from './services/source.service';
import {SourceGroupService} from './services/source-group.service';
import {StopActionService} from './services/stop-action.service';
import { MerchantSetupService } from './services/merchant-setup.service';
import { SweepAccountService } from './services/sweep-account.service';
import {ServicePointSetupService} from './services/service-point-setup.service';
import {BfgMessageLinkService} from './services/bfg-message-link.service';
import {SetupAccountServiceService} from './services/setup-account-service.service';
import { TemplatesService } from './services/templates.service';
import { TokensService } from './services/tokens.service';
import { EventlinksService } from './services/eventlinks.service';
import { AwaitingTransactionService } from './services/awaiting-transaction.service';

@NgModule({
  imports: [CommonModule]
})
export class MBEServiceModule {
  static forRoot(config: Environment): ModuleWithProviders<MBEServiceModule> {
    return {
      ngModule: MBEServiceModule,
      providers: [
          AuthService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        LoggingService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        AutoLogoutService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        BankAccountServiceService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        BfeeDetailService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        BfeeGroupService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        BfeeSourceService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        ChartOfAccountService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        FeeSourceService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        FinancialService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        NotificationService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        RiskClassService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        SourceService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        SourceGroupService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        StatmentDescriptionCodeService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        StopActionService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        MerchantSetupService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        SweepAccountService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        ServicePointSetupService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        BfgMessageLinkService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        SetupAccountServiceService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        TemplatesService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        TokensService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        EventlinksService,
        {
          provide: mbeConfigService,
          useValue: config
        },
        // See C001 - 2026-08-20 - HE
        AwaitingTransactionService,
        {
          provide: mbeConfigService,
          useValue: config
        },

      ]
    };
    }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Registered AwaitingTransactionService in MBEServiceModule.forRoot with mbeConfigService. Previous behavior: forRoot provided other MBE HTTP services only; ATA had no Config injection via this module. New behavior: AwaitingTransactionService is listed in forRoot providers so it receives the same environment as BfeeGroupService (REST_SERVER_HOST + MBE url). Reason: ATA /awt APIs use MBengine_ENS. Context: Portaladmin already imports MBEServiceModule.forRoot(config). Impact: No new environment keys; other apps that import MBEServiceModule get the service available when injected. - 2026-08-20 - HE

